export default class AnalysisSalesScheduleActions {

    static NEW_DATA = 'NEW_DATA';
    static RESET_DATA = 'RESET_DATA';
    static GET_HELPER_REPORTVISIT = 'GET_HELPER_REPORTVISIT';
    static GET_DATA = 'GET_DATA';
    static ERROR_DATA='ERROR_DATA';
    static SHOW_DATA = 'SHOW_DATA';
    static LOADING_DETAILS = 'LOADING_DETAILS';
    static LOADED_DETAILS = 'LOADED_DETAILS';

    static loadingDetails(){
      return {
        type:AnalysisSalesScheduleActions.LOADING_DETAILS
      }
    }

    static error(error){
      return {
        type:  AnalysisSalesScheduleActions.ERROR_DATA,
        payload: error
      };
    }

    static loadedDetails(data){
      return {
        type:AnalysisSalesScheduleActions.LOADED_DETAILS,
        payload:data,
      }
    }

    static new(){
      return {
        type:AnalysisSalesScheduleActions.NEW_DATA
      }
    }
    static process(){
      return {
        type:AnalysisSalesScheduleActions.GET_DATA
      }
    }

    static setTracking(data){
      return {
        type:AnalysisSalesScheduleActions.SHOW_DATA,
        payload:data
      }
    }

    static reset(){
      return {
        type:AnalysisSalesScheduleActions.RESET_DATA
      }
    }
    static helper(data){
      return {
        type:AnalysisSalesScheduleActions.GET_HELPER_REPORTVISIT,
        payload:data
      }
    }
    
  }
  
  